/* eslint-disable */
// TODO: Remove this lint disable when AI toggle is removed
// from this file and everyone is using ConversationUIApp_v2

import { createApp, h } from 'vue'
import ConversationUIApp from './ConversationUIApp.vue'
import ConversationUIApp_v2 from './ConversationUIApp_v2.vue'
import autoexpandHeight from '../../directives/autoexpandHeight'
import { ConversationSpec, Options } from '@/entities/conversation'
import { getCaptchaToken } from '@/utils/grecaptcha'
import {
    logCaptchaLaunched,
    verifyAwsWafChallenge,
    verifyCaptchaToken,
} from '@/api/conversation'
import 'core-js/stable'
import 'regenerator-runtime/runtime'
import { defaultCsatOptions } from '@/transforms/conversation'
import { SurveyLinkConfig } from '@/entities/appstore/survey-links'

interface Params {
    [key: string]: string
}

function parseData<T>(id: string, fallback: T): T {
    const el = document.getElementById(id)
    if (!el) {
        return fallback
    }
    return (JSON.parse(el.innerText) as T) || fallback
}

document.addEventListener('DOMContentLoaded', async () => {
    const spec = parseData<ConversationSpec>('conversation-spec', [])
    const params = parseData<Params>('conversation-params', {})
    const preview = parseData<boolean>('conversation-preview', false)
    const csatLabels = parseData<Options>(
        'conversation-csatLabels',
        defaultCsatOptions()
    )
    const recaptchaSitekey = parseData<string>('recaptchaSitekey', '')
    const browserTracking = parseData<boolean>('browserTracking', false)
    const surveyLinkConfig = parseData<SurveyLinkConfig>('surveyLinkConfig', {})
    const isDynamicSurvey = parseData<boolean>('isDynamicSurvey', false)

    const id = 'app'

    if (!document.getElementById(id)) {
        return
    }

    await verifyReCaptcha(params, recaptchaSitekey)

    // We mount the app whether captcha succeeded or not
    // because if it failed, question->botdetected will
    // have been marked true, and any answers sent will be disregarded
    let vm
    if (isDynamicSurvey) {
        vm = createApp({
            components: {
                ConversationUIApp_v2,
            },
            data: function () {
                return {
                    params,
                    spec,
                }
            },
            render() {
                return h(ConversationUIApp_v2, {
                    spec: this.spec,
                    params: this.params,
                    csatLabels,
                    preview,
                    recaptchaSitekey,
                    browserTracking,
                    surveyLinkConfig,
                    onUpdatespec: (newValues) => {
                        this.params.answer = newValues.answer
                        this.spec = newValues.spec
                    },
                })
            },
        })
    } else {
        vm = createApp({
            components: {
                ConversationUIApp,
            },
            data: function () {
                return {
                    params,
                    spec,
                }
            },
            render() {
                return h(ConversationUIApp, {
                    spec: this.spec,
                    params: this.params,
                    csatLabels,
                    preview,
                    recaptchaSitekey,
                    browserTracking,
                    surveyLinkConfig,
                    onUpdatespec: (newValues) => {
                        this.params.answer = newValues.answer
                        this.spec = newValues.spec
                    },
                })
            },
        })
    }
    vm.directive('autoexpand-height', autoexpandHeight())
    vm.mount(`#${id}`)

    triggerAwsWafChallenge(params)
})

const verifyReCaptcha = async function (params, recaptchaSitekey) {
    if (window.hasOwnProperty('grecaptcha')) {
        const action = 'conversation'
        const token = await getCaptchaToken(recaptchaSitekey, action)
        logCaptchaLaunched(params.slug, params.conversationSlug)
        await verifyCaptchaToken(
            params.slug,
            token,
            action,
            params.answer,
            params.conversationSlug
        )
    }
}

const triggerAwsWafChallenge = function (params) {
    const awsWafChallengeSDKScript =
        document.getElementById('awsWafChallengeSDK')
    if (awsWafChallengeSDKScript) {
        if ((window as any).AwsWafIntegration) {
            verifyAwsWafChallenge(params.slug, params.conversationSlug)
            return
        }
        // SDK is not loaded yet
        awsWafChallengeSDKScript.addEventListener('load', async () => {
            verifyAwsWafChallenge(params.slug, params.conversationSlug)
        })
    }
}
